import script from "./DelayCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DelayCard.vue?vue&type=script&setup=true&lang=js"

import "./DelayCard.vue?vue&type=style&index=0&id=05e51d39&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e51d39"]])

export default __exports__